<template>
  <div class="button-container">
    <button type="button" class="btn btn-primary" @click="loginClicked">
      Login with your Sharedo Account
    </button>
    <div class="disconnect">
      <router-link to="/settings"
        >Or click here to disconnect from sharedo.</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    loginClicked: function() {
      this.$emit("login");
    },
  },
  emits: ["login"],
};
</script>
<style lang="scss" scoped>
.button-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  & > .disconnect {
    font-size: 0.8rem;
    margin-top: 10px;
  }
}
</style>
